import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"

import '../styles/LogisticsIndustry.css';

import LogisticsIndustryImg from '../assets/LogisticsIndustryImg.jpg'

const LogisticsIndustry = () => {

  return (
    <div className="LogisticsIndustry">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="LogisticsIndustry-hero-clean">
  <div className="hero-text">
    <h1>Logistics Industry</h1>
    <p>
        Logistics combined with a suitable sensor technology is a significant factor in meeting the growing requirements on an efficient supply chain in regard to throughput, availability, flexibility and safety.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={LogisticsIndustryImg} alt="Logistics Industry" />
  </div>
</section>


<ProcessDevice />
<OurProductsSection />

      <Footer />
    </div>
  );
};
export default LogisticsIndustry;